module.exports = __webpack_public_path__ + "static/asmet-white_white@2x-1c7ed1a6e530b7b2628725363052400f.png";